import React from 'react';
import TableParte from './TableParte';
import './css/processo.css';
// import { IPartes } from '../../modelo/Partes';
import { Partes } from '../../modelo/dominio/Partes';

interface IPropsPartesProcesso {
    partes: Partes;
    mensagemErro?: string;
}
class PartesProcesso extends React.Component<IPropsPartesProcesso> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ul className="divFlexColumn lista">
                <li>
                    <b className="titulo">Partes:</b>
                    {this.props.mensagemErro && (
                        <div style={{ color: '#d32f2f', fontSize: '1rem', fontWeight: 400, whiteSpace: 'pre-line' }}>
                            {this.props.mensagemErro}
                        </div>
                    )}
                    <ul className='data-hj-suppress'>
                        <li className="lista-align-left">
                            {this.props.partes && this.props.partes.ATIVO && this.props.partes.ATIVO.map(
                                function (atv, index) {
                                    return (
                                        <TableParte parte={atv} key={index} />
                                    );
                                })
                            }
                        </li>
                        <li className="lista-align-left">
                            {this.props.partes && this.props.partes.PASSIVO && this.props.partes.PASSIVO.map(
                                function (pass, index) {
                                    return (
                                        <TableParte parte={pass} key={index} />
                                    );
                                })
                            }
                        </li>
                        <li className="lista-align-left">
                            {this.props.partes && this.props.partes.TERCEIROS && this.props.partes.TERCEIROS.map(
                                function (terc, index) {
                                    return (
                                        <TableParte parte={terc} key={index} />
                                    );
                                })
                            }
                        </li>
                    </ul>
                </li>
            </ul>
        );
    }
}

export default PartesProcesso;
